
<component :is="as" class="helper-text">
  <slot />

  <helper-icon
    :help-text="helpText"
    :hide-help="hideHelp"
  />
</component>
